var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"move-btn-list-container",class:{ large: _vm.large, small: _vm.small, rounded: _vm.rounded }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }